import type { Fields } from '../types/Fields';

/**
 * Check that an object has the correct fields
 */
export const hasFields = <T extends object>(object: T | any, fields: Fields<Exclude<T, undefined>>): object is T =>
    object && typeof object === 'object' && fields.every((field) => field in object);
